import { TrackCellType } from '@multirx/shared/types/track.js';
import {
  resolveTrackCellBonusVisual,
  trackCellBonusVisualClass,
} from '@multirx/shared/game/trackCellBonusVisual.js';

export type TurnHistoryRollRow = {
  roll: number | null;
  effectiveMove: number | null;
  moveBudget?: number | null;
  bonusCellType?: TrackCellType | null;
  mainPathIndex?: number | null;
};

export type TurnHistoryDisplayRow = {
  playerIndex: number;
  rank: number;
  rollOrder?: number;
  driverName: string;
  roll: number | null;
  effectiveMove: number | null;
  moveBudget?: number | null;
  bonusCellType?: TrackCellType | null;
  mainPathIndex?: number | null;
};

/** Lignes d’historique dans l’ordre de lancer (pas le classement piste). */
export function turnHistoryRowsInRollOrder(entry: {
  rows: readonly TurnHistoryDisplayRow[];
  turnOrderAtRoundStart?: readonly number[];
}): TurnHistoryDisplayRow[] {
  const byPlayer = new Map(entry.rows.map((r) => [r.playerIndex, r]));
  if (entry.turnOrderAtRoundStart?.length) {
    const ordered: TurnHistoryDisplayRow[] = [];
    const seen = new Set<number>();
    for (const playerIndex of entry.turnOrderAtRoundStart) {
      const row = byPlayer.get(playerIndex);
      if (row) {
        ordered.push(row);
        seen.add(playerIndex);
      }
    }
    for (const row of entry.rows) {
      if (!seen.has(row.playerIndex)) ordered.push(row);
    }
    return ordered;
  }
  return [...entry.rows].sort((a, b) => a.rank - b.rank);
}

/** Total affiché entre parenthèses : dé + bonus case (pas les cases parcourues). */
export function turnHistoryDisplayTotal(row: TurnHistoryRollRow): number | null {
  if (row.moveBudget != null && row.moveBudget > 0) return row.moveBudget;
  if (row.roll != null && row.roll > 0 && row.effectiveMove != null && row.effectiveMove > 0) {
    return row.effectiveMove;
  }
  return null;
}

/** HTML du résultat de dé : dé brut + (total bonusé), colorés selon le type de case. */
export function formatTurnHistoryRollMarkup(row: TurnHistoryRollRow): string {
  const rollNum = row.roll != null && row.roll > 0 ? row.roll : null;
  const rollText = rollNum != null ? String(rollNum) : '—';
  const visual = resolveTrackCellBonusVisual(row.bonusCellType, row.mainPathIndex);
  const cellClass = trackCellBonusVisualClass(visual);
  const rollHtml =
    rollNum != null && cellClass
      ? `<span class="play-race-history-roll-base ${cellClass}">${rollText}</span>`
      : rollText;
  const total = turnHistoryDisplayTotal(row);
  if (total == null) {
    return rollHtml;
  }
  return `${rollHtml} <span class="play-race-history-roll-effective ${cellClass}">(${total})</span>`;
}
